import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info';
  actionText?: string;
  actionCallback?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts = signal<Toast[]>([]);
  private nextId = 0;

  show(message: string, type: Toast['type'] = 'info', actionText?: string, actionCallback?: () => void) {
    const id = this.nextId++;
    
    this.toasts.update(currentToasts => [
      ...currentToasts, 
      { id, message, type, actionText, actionCallback }
    ]);

    if (!actionText) {
      setTimeout(() => this.remove(id), 5000);
    }
  }

  remove(id: number) {
    this.toasts.update(currentToasts => currentToasts.filter(t => t.id !== id));
  }
}